import { render, staticRenderFns } from "./eventType.vue?vue&type=template&id=16abb020&scoped=true&"
import script from "./eventType.vue?vue&type=script&lang=js&"
export * from "./eventType.vue?vue&type=script&lang=js&"
import style0 from "./eventType.vue?vue&type=style&index=0&id=16abb020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16abb020",
  null
  
)

export default component.exports